import React from 'react';
import ExtendedModal from 'components/Shared/Modal';
import useTranslation from 'utils/hooks/useTranslation';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import CorporateClientRegistrationFormV2 from 'pages/Corporations/RegisterCorporation/CorporateClientRegistrationFormV2';
import useCompanyDetailsModal from './useCompanyDetailsModal';

// Asks an existing UK org without an Allstar credit account for the address and tax number it
// skipped at registration. It cannot be dismissed; saving the details closes it.
const CompanyDetailsModal = () => {
  const { translateText } = useTranslation();
  const { isVisible, isMobile, isLoading, countryCode, onSubmit } = useCompanyDetailsModal();

  if (!isVisible) return null;

  return (
    <ExtendedModal
      visible={isVisible}
      closable={false}
      footer={null}
      wrapClassName="modalWrapper"
      width={565}
      data-testid="companyDetailsModal"
    >
      <CorporateClientRegistrationFormV2
        isMobile={isMobile}
        isLoading={isLoading}
        onSubmit={onSubmit}
        countryCode={countryCode}
        title={translateText('corporateAccounts.corporations.companyDetails.title')}
        description={translateText('corporateAccounts.corporations.companyDetails.description')}
        submitAmplitudeEvent={AMPLITUDE_EVENT_TYPES.companyDetailsModalSaveButton}
      />
    </ExtendedModal>
  );
};

export default CompanyDetailsModal;
